/* global I18n */

import OrderItemsStore from './order_items_store'
import Currency from 'utils/currency'
import WebsiteConfigs from 'website_configs/website_configs'

class ShoppingCart {
  static render ($parent) {
    return new ShoppingCart($parent)
  }

  constructor ($parent) {
    this.isPayPal = $('[data-paypal-key]').data('paypal-key')
    this.isStripe = $('[data-stripe]').data('stripe')

    this.$parent = $parent
    this.showBack = true
    this.onMakeOffer = () => {
    }
    this.onBack = () => {
    }
    this.onNext = () => {
    }
  }

  removeItem = (index) => {
    OrderItemsStore.removeItem(index)
    this.render()
  }

  increaseQuantity = (index) => {
    OrderItemsStore.increaseQuantity(index)
    this.render()
  }

  decreaseQuantity = (index) => {
    OrderItemsStore.decreaseQuantity(index)
    this.render()
  }

  maxQuantityReached = (item) => {
    return item.quantity === item.maxQuantity
  }

  showErrorMessage = (message) => {
    $('#error_alert').show()
    $('#error_alert .error-message').html(message)
  }

  hideErrorMessage = () => {
    $('#error_alert').hide()
  }

  totalPrice = () => {
    return OrderItemsStore.getTotalPriceData()
  }

  bindEvents = () => {
    this.$element.find('.shopping-cart--remove').on('click', (e) => {
      const index = $(e.currentTarget).closest('.item-index').data('index')
      this.removeItem(index)
    })

    this.$element.find('.shopping-cart--plus').on('click', (e) => {
      const index = $(e.currentTarget).closest('.item-index').data('index')
      this.increaseQuantity(index)
    })

    this.$element.find('.shopping-cart--minus').on('click', (e) => {
      const index = $(e.currentTarget).closest('.item-index').data('index')
      this.decreaseQuantity(index)
    })

    this.$element.find('.shopping-cart--back').on('click', () => this.onBack())
    this.$element.find('.shopping-cart--checkout').on('click', (e) => this.onCheckoutClick(e))
    this.$element.find('.shopping-cart-offer--checkout').on('click', () => this.onMakeOffer())
  }

  onCheckoutClick = (e) => {
    const $targetEl = $(e.currentTarget)

    $targetEl.prop('disabled', true)
    $targetEl.find('span').text(I18n.t('processing'))

    this.hideErrorMessage()
    this.onNext()
  }

  renderError (error) {
    if (error.status === 422) {
      const errors = Object.entries(error.responseJSON['errors']).map(([_, values]) => values).join('<br>')
      console.error(errors)
      this.showErrorMessage(errors)
    } else {
      console.error(error)
      this.showErrorMessage(I18n.t('checkout_error'))
    }

    const $nextBtn = this.$element.find('.shopping-cart--checkout')
    $nextBtn.prop('disabled', false)
    $nextBtn.find('span').text(this.nextBtnTranslation())
  }

  render = () => {
    OrderItemsStore.updateItemsAsync().then(() => {
      this.$parent.html(this.template).ready(() => {
        this.$element = this.$parent.children().first()
        this.bindEvents()
        this.$form = this.$element.find('form')
      })
    })
  }

  renderItemPrice = (item) => {
    const currency = Currency.getCurrency()
    if (currency && item.availablePrices) {
      const listingPrice = item.availablePrices.find(el => el.currency === currency.toUpperCase())
      if (listingPrice) {
        return listingPrice.display_price
      }
    }
    return 0
  }

  renderItemStatus = (item) => {
    if (WebsiteConfigs.createWebshopLead) return ''

    if (item.listing_type === 'sold') {
      return `<span class="badge badge-warning">${I18n.t('sold')}</span>`
    } else if (!item.with_stock) {
      return `<span class="badge badge-warning">${I18n.t('out_of_stock')}</span>`
    }
    return ''
  }

  nextBtnKey () {
    let nextBtnKey = 'submit_order'
    if (WebsiteConfigs.privatePriceWebshop || WebsiteConfigs.createWebshopLead) {
      nextBtnKey = 'submit_quote_request'
    } else if (WebsiteConfigs.allowOffer) {
      nextBtnKey = 'buy_it_now'
    } else if (this.isPayPal || this.isStripe) {
      nextBtnKey = 'checkout'
    }
    return nextBtnKey
  }

  nextBtnTranslation () {
    if (WebsiteConfigs.submitOrderButtonText) {
      return WebsiteConfigs.submitOrderButtonText
    }
    return I18n.t(this.nextBtnKey())
  }

  backBtnKey () {
    let backBtnKey = 'continue_shopping'
    if (WebsiteConfigs.privatePriceWebshop || WebsiteConfigs.createWebshopLead) {
      backBtnKey = 'continue_browsing'
    }
    return backBtnKey
  }

  backBtnTranslation () {
    return I18n.t(this.backBtnKey())
  }

  get template () {
    const items = OrderItemsStore.getItems()
    const showQuantity = !WebsiteConfigs.createWebshopLead && WebsiteConfigs.showListingQuantity
    const showPrice = !(WebsiteConfigs.privatePriceWebshop || WebsiteConfigs.createWebshopLead)

    if (items.length === 0) {
      return `<div class="text-center"><h3>${I18n.t('shopping_cart_is_empty')}</h3></div>`
    }

    return `
      <div>
        <div class="d-none d-md-block">
          <div class="alert alert-danger" id="error_alert" style="display: none;">
            <div class="error-message"></div>
          </div>
          <div class="d-flex mb-2">
            <div class="d-flex" style="width: 350px">
              <div class="mr-3">#</div>
              <div>${I18n.t('title')}</div>
            </div>
            <div class="d-flex mb-1 text-sm-right justify-content-end w-100">
              ${showPrice ? `<div class="mr-3 text-left">${I18n.t('price')}</div>` : ''}
              ${showQuantity ? `<div class="mr-3 text-left" style="width: 110px">${I18n.t('quantity')}</div>` : ''}
              <div style="width: 30px"></div>
            </div>
          </div>
        </div>
        ${items.map((item, index) => `
          <div data-index="${index}" class="item-index d-flex flex-row flex-wrap flex-md-nowrap justify-content-between mb-2 align-items-start border-bottom">
            <div class="d-flex mb-1 tr" style="width: 350px;">
              <div class="mr-3 scope="row">${index + 1}</div>
              <div style="max-width: 350px;" class="item-title">
                <a class="mr-2 text-dark font-weight-bold" href="/listings/${item.listing_id}">${item.title}</a>
                ${this.renderItemStatus(item)}
              </div>
            </div>
            <div class="d-flex flex-md-nowrap flex-wrap mb-1 text-sm-right justify-content-end w-md-100 w-auto align-items-center">
              ${showPrice ? `<div class="text-right mb-2 mb-md-0">${this.renderItemPrice(item)}</div>` : ''}
              <div class="d-flex flex-nowrap ml-3">
                ${showQuantity ? `
                  <div class="mr-3">
                    <div class="input-group" style="width: 110px;">
                      <div class="input-group-prepend">
                        <button class="btn btn-sm btn-dark shopping-cart--minus" ${item.quantity === 1 ? ' disabled' : ''}>
                          <i class="fa fa-minus"></i>
                        </button>
                      </div>
                      <div class="text-center item-quantity item-quantity">${item.quantity}</div>
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-dark shopping-cart--plus" ${this.maxQuantityReached(item) ? ' disabled' : ''}>
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ` : ''}
                <div class="text-right mb-1">
                  <button class="btn btn-sm btn-danger shopping-cart--remove">
                    <i class="fa fa-times fa-solid"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>`).join('')}
        <div>
          ${showPrice ? `
            <div class="text-right">
              <h4>${I18n.t('total')}: ${this.totalPrice()}</h4>
              ${this.isPayPal ? `
                <div class="mb-2 text-grey">
                  <i>* ${I18n.t('before_tax_and_shipping')}</i>
                </div>
              ` : ''}
            </div>
          ` : ''}
          ${WebsiteConfigs.gdprCompliance ? `<div class="form-check mb-3">
            <label for="receive_newsletters">
              <input type="checkbox" name="receive_newsletters" id="receive_newsletters" value="" class="form-check-input">
              ${I18n.t('receive_newsletters')}
            </label>
          </div>` : ''}
          <button class="btn btn-secondary shopping-cart--back">
            <i class="fa fa-chevron-left"></i>
            ${this.backBtnTranslation()}
          </button>
          <button class="btn btn-success shopping-cart--checkout checkout-button-margin">
            <i class="fa fa-shopping-cart"></i>
            <span>${this.nextBtnTranslation()}</span>
          </button>
          ${WebsiteConfigs.allowOffer ? `
            <button class="btn btn-primary shopping-cart-offer--checkout checkout-button-margin">
              ${I18n.t('make_an_offer')}
            </button>` : ''}
        </div>
      </div>
    `
  }
}

export default ShoppingCart
